import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=47374bbe&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47374bbe')) {
      api.createRecord('47374bbe', component.options)
    } else {
      api.reload('47374bbe', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=47374bbe&", function () {
      api.rerender('47374bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26dA8BmzAFt9P/JS/pricehelp.vue"
export default component.exports